import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Identify the Lock',
    desc: "Use the audit worksheet to find which of the 'Big Three' joints is causing your pain."
  }, {
    num: '02',
    title: 'Apply the Matrix',
    desc: 'Perform the 8-minute chair-based sequence once per day (no equipment needed).'
  }, {
    num: '03',
    title: 'Reset the System',
    desc: "Follow the 'Action-Plan' checklists to maintain a pain-free body even during 10-hour workdays."
  }];
  return <section className="w-full bg-dark-panel py-24 border-b border-dark-lighter" data-id="element-108">
      <div className="max-w-5xl mx-auto px-6" data-id="element-109">
        <FadeIn data-id="element-110">
          <h2 className="font-display text-4xl md:text-5xl font-bold uppercase mb-16 text-center" data-id="element-111">
            How It <span className="text-cyan-accent" data-id="element-112">Works</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-113">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[2px] bg-dark-lighter z-0" data-id="element-114"></div>

            {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-115">
                <div className="w-24 h-24 rounded-full bg-dark border-2 border-cyan-accent flex items-center justify-center mb-8 shadow-[0_0_15px_rgba(0,212,255,0.2)]" data-id="element-116">
                  <span className="font-display text-3xl font-bold text-cyan-accent" data-id="element-117">
                    {step.num}
                  </span>
                </div>
                <h3 className="font-display text-2xl uppercase mb-4 text-white" data-id="element-118">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-119">{step.desc}</p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}